import { render, staticRenderFns } from "./CompareRemoveIcon.vue?vue&type=template&id=55ac3ff7&"
import script from "./CompareRemoveIcon.vue?vue&type=script&lang=js&"
export * from "./CompareRemoveIcon.vue?vue&type=script&lang=js&"
import style0 from "./CompareRemoveIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports